import WIDGETS from './widgets';

export default {
	name: 'ticket_survey',
	spacing: 2,
	sx: { width: '100%', margin: '0px' },
	widgets: [
		{
			content: WIDGETS.SURVEY,
			breakpoints: { xs: 12 },
			lazy_loading: 0,
			component_props: {
				ref_type: 'tickets_surveys',
			},
		},
	],
};
